
import './sentry'



import Vue from 'vue'
import WebViewBridge from 'vue-bridge-webview'
import FastClick from 'fastclick'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import router from './router'
import App from './App'
import 'babel-polyfill'
import util from './common/js/my_util'
import './common/css/commom.css'
import BaseComplugin from './plugins/globalmount'
import './config'
import Vant from 'vant'
import 'vant/lib/vant-css/index.css'

Vue.use(Vant)

Vue.use(BaseComplugin)       

Vue.use(WebViewBridge)

Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)
FastClick.attach(document.body)
Vue.prototype.isDev = process.env.NODE_ENV !== 'production'
Vue.prototype.$util = util
Vue.config.productionTip = false
Vue.prototype.initTime = 3000
router.beforeEach((to, from, next) => {
window.document.title = to.meta.title
next()
})
/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js